<template>
	<div class="text-input-wrapper" :class="input.class">
		<input
			type="text"
			v-model="value"
			:class="{
		'error': !isValid,
		'success': isValid,
		'uppercase': this.input.textTransform == 'uppecase',
		'lowercase': this.input.textTransform == 'lowercase'
		}"
			:name="input.name"
			:maxlength="input.maxChars"
			:placeholder="input.placeholder"
			@mouseup="selectAll($event)"
			@blur="[updateValidationStatus(), validateInput(), textTransform()]"
		/>
		<span class="price" v-if="input.price > 0" v-text="formatPrice(input.price)"></span>
		<div class="error-message" v-if="this.errorMessage">{{this.errorMessage}}</div>
	</div>
</template>

<script>
import InputBase from "./InputBase";
import helper from "@/mixins/helper.js";

export default {
	name: "InputText",
	extends: InputBase,
	props: ["option"],
	mixins: [helper],
	data: function() {
		return {
			input: this.option.input,
			value: this.option.input.default || "",
			errorMessage: ""
		};
	},
	watch: {
		value: function() {
			this.saveToStore();
		}
	},
	created: function() {
		// Save default value to store
		if (this.value) {
			this.saveToStore();
		}
		// Save default validation status to store
		this.updateValidationStatus();
	},
	computed: {
		/**
		 * returns true if input value contains only allowed characters
		 * returns false if input value contains illegal characters OR if value is empty
		 */
		regexMatch() {
			if (this.input.regex) {
				let expression = new RegExp(this.input.regex.expression);
				return this.value.match(expression);
			}
			return true;
		},
		hasMinChars() {
			return this.input.minChars ? this.value.length >= this.input.minChars : true;
		},
		hasMaxChars() {
			return this.input.maxChars ? this.value.length <= this.input.maxChars : true;
		}
	},
	methods: {
		// Over written method
		updateValidationStatus() {
			// Call BaseInput
			this.setValidationStatusToStore(this.option.id, this.isValid());
		},
		// Over written method
		isValid() {
			// Input is valid if not set as required option
			if (!this.option.input.required) {
				return true;
			}
			// Input invalid if includes illegal characters or empty
			if (!this.regexMatch || !this.hasMinChars || !this.hasMaxChars) {
				return false;
			}
			return true;
		},
		validateInput() {
			/**
			 * Extra validation for text input.
			 * Validates that only allowed characters are used (ignores empty input).
			 * Provides instant error message.
			 */
			if (!this.regexMatch && this.value.length !== 0) {
				this.errorMessage = this.input.regex.error || "Invalid format!";
			} else if (!this.hasMinChars) {
				let characters = this.input.minChars > 1 ? "characters" : "character";
				this.errorMessage =
					this.input.minChars == this.input.maxChars
						? this.input.minChars + " "+characters+" required!"
						: "Minimum of " + this.input.minChars + " "+characters+" required!";
			} else if (!this.hasMaxChars) {
				this.errorMessage = "Maximum of " + this.input.maxChars + " characters allowed!";
			} else {
				this.errorMessage = "";
			}
		},
		textTransform() {
			if (this.input.textTransform) {
				// Uppercase
				if (this.input.textTransform == "uppercase") {
					this.value = this.value.toUpperCase();
				}
				// Lowercase
				if (this.input.textTransform == "lowercase") {
					this.value = this.value.toLowerCase();
				}
			}
			return this.value;
		},
		saveToStore() {
			this.setSelectedOptionToStore(this.input.name, {
				name: this.option.name + ": " + this.textTransform(this.value),
				sku: this.option.sku,
				position: this.option.position,
				price: this.value.length > 0 ? this.option.input.price : 0,
				value: this.textTransform(this.value),
				previewMutations: this.option.previewMutations
			});
		},
		selectAll(event) {
			if (this.input.selectAll) {
				event.target.select();
			}
		}
	}
};
</script>

<style lang="scss">
.text-input-wrapper {
	input {
		padding: 16px 8px;

		&.error {
			border: 2px solid #f00;
		}

		&.uppercase {
			text-transform: uppercase;
		}

		&.lowercase {
			text-transform: lowercase;
		}
	}

	.required-field,
	.error-message {
		color: #f00;
		margin-top: 8px;
	}
}
</style>